import useAxiosInterceptor from 'src/services/interceptor';
import { patientApiPaths } from '../constants';

class MonthEndAlertsService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getMonthEndAlertCount = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getMonthEndAlertCount}${
        payload?.source !== 'DASHBOARD' ? '/closeout' : ''
      }/alert-count`,
      {
        params: payload?.param,
      }
    );
  };
  getMonthEndAlertThemeCount = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getMonthEndAlertCount}/theme?timePeriod=${payload.timePeriod}`
    );
  };
  getOwnerAlertCount = (payload: any) => {
    return this.axiosInstance.get(`${patientApiPaths.getMonthEndAlertCount}/closeout/owner`, {
      params: payload?.param,
    });
  };

  getListOfMonthEndAlerts = (payload: any) => {
    const path = payload?.source === 'CLOSEOUT' ? 'closeout/range' : 'all';
    return this.axiosInstance.get(`${patientApiPaths.getMonthEndAlertCount}/${path.trim()}`, {
      params: { ...payload?.param },
    });
  };

  certifyMonthEndAlertCycle = (payload: object) => {
    return this.axiosInstance.post(patientApiPaths.certifyMonthEnd, payload);
  };

  getCertificationStatus = (payload: object) => {
    return this.axiosInstance.get(patientApiPaths.getCertificationStatus, {
      params: { ...payload },
    });
  };

  getMonthEndAlertsPdfUrl = (startDate: string, endDate: string) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getMonthEndAlertCount}/print?startDate=${startDate}&endDate=${endDate}`
    );
  };
}

const monthEndAlertsService = new MonthEndAlertsService();

Object.freeze(monthEndAlertsService);

export default monthEndAlertsService;
